
  import { mapGetters } from 'vuex'
  export default {
    name: 'AnnouncementText',
    computed: {
      ...mapGetters({
        announcement: 'cms/announcement'
      }),
      announcementText() {
        const items = this.announcement?.items || []
        const visibleItems = this.getVisibleItems(items)

        if (!visibleItems.length) return ''

        return visibleItems
          .sort((a, b) => a?.sequence - b?.sequence)
          .map((item, index) => {
            const title = this.getLocaleLang(item.title)
            return title ? `${index + 1}) ${title}` : ''
          })
          .filter(Boolean)
          .join('  •  ') // Adds spacing and delimiter between messages
      }
    },
    mounted() {
      // Call this store action only when the user is not on the home page and mobile device
      if (this.$route.path !== '/' && !this.isMobileOnly()) {
        this.$store.dispatch('cms/cmsComponentCode', {
          platform: 1,
          component_code: 'Announcement'
        })
      }
    }
  }
